import React, { useCallback } from 'react';
import { CountryCode } from '@utmost.co/utmost-design-system';
import { FlagIcon } from '@utmost.co/utmost-design-system/flags';
import { getElementFields } from '../../forms/utils/getElementFields';
import { SmartformElementData } from '../../types';
import { TypeaheadOption } from '../../atoms/SelectTypeahead/parts/useApiTypeahead';
import { SelectTypeaheadMulti } from '../../fields/SelectTypeaheadMulti';
import { codesISO3, codesISO2, CitizenshipModel } from './Codes';

export const Citizenship: React.FC<SmartformElementData> = (props) => {
  const [field] = getElementFields(props).required;

  const useIso3 = props.element.params?.iso3 || false;
  const options = (useIso3 ? codesISO3 : codesISO2).map(
    (code) =>
      ({
        id: code.type,
        value: code.type,
        label: code.name,
        code: code.type,
        icon: <FlagIcon country={code.type.toUpperCase() as CountryCode} />
      }) as TypeaheadOption<string>
  );

  const mapOutput = useCallback(
    (values?: string[]) =>
      values
        ? values.map(
            (value) =>
              ({
                type: value
              }) as CitizenshipModel
          )
        : undefined,
    []
  );
  const mapInput = useCallback((values?: CitizenshipModel[]) => {
    if (!values) return [];
    return values.map((value) => value.type);
  }, []);

  return (
    <SelectTypeaheadMulti<string, CitizenshipModel[]>
      values={options}
      name={field.name}
      key={field.name}
      placeholder={field.hint}
      required={field.validation.required}
      helpText={field.helpText}
      infoText={field.infoText}
      fullWidth
      label={field.label}
      initialValue={field.initialValue}
      mapOutputValue={mapOutput}
      mapInputValue={mapInput}
    />
  );
};
